import {CertificateMethod, SpecialistViewInterface} from '@interfaces/specialist.interface';
import {SpecialistsProvider} from '@providers/specialists/specialists.provider';

export class SpecialistListItem {
    id: number;
    name: string;
    job: string;
    nkMethods: NkMethod[] = [];
    hasPbCertificates: boolean;

    constructor(
        private _rawData: SpecialistViewInterface,
    ) {
        this.setAttributes();
        this.calculateNkCertificateValues();
    }

    get rawData() {
        return this._rawData;
    }

    private setAttributes() {
        this.id = this.rawData.id;
        this.name = this.rawData.full_name;
        this.job = this.rawData.job_title;
        this.hasPbCertificates = this.rawData.certificate_pb.length > 0;
    }

    private calculateNkCertificateValues() {
        const actualNkCertificated = this.rawData.certificate_nk || [];

        const actualMethods: CertificateMethod[] = actualNkCertificated.reduce((acc, item) => {
            acc.push(...item.methods.filter(m => SpecialistsProvider.isMethodDateActual(m.expiration_date)));
            return acc;
        }, []);

        this.nkMethods = actualMethods.map((method) => {
            return {
                title: method.short_title,
                level: +method.level,
                objects: method.objects_string.split(', ')
            };
        });
    }
}

interface NkMethod {
    title: string;
    level: number;
    objects: string[];
}
